import publicIp from 'public-ip';
import { logFetchError } from '../services/datadog';

export default async function fetchLocFromIP() {

  var bookRegion = null;
  const ip = await publicIp.v4();
  var url = `https://api.ipstack.com/${ip}?access_key=37a7faaa40222eec402c67e1f6a154c8`;

  try {
    var r = await fetch(url);
  } catch (err) {
    logFetchError(url, null, err);
    return bookRegion;
  }

  if (r.status > 299 || r.status < 200) {
    logFetchError(url, r.status, null);
    return bookRegion;
  }

  var data = await r.json();
  let region = data.region_code;

  // let zip = data['zip'];
  // url = `https://maps.googleapis.com/maps/api/geocode/json?address=${zip}&key=AIzaSyD2IisBYHFPs6WMagno82Ig3o5XbK4D070`;

  // try {
  //   r = await fetch(url);
  // } catch (err) {
  //   logFetchError(url, null, err);
  //   return bookRegion;
  // }

  // if (r.status > 299 || r.status < 200) {
  //   logFetchError(url, r.status, null);
  //   return bookRegion;
  // }

  // data = await r.json();
  // let add = data['results'][0]['address_components'];
  // let city = null;
  // let region = null;
  // for (let i = 0; i < add.length; i++) {
  //   let d = add[i];
  //   if (d['types'][0] === 'locality' && d['types'][1] === 'political') {
  //     city = d['short_name'];
  //   } else if (
  //     d['types'][0] === 'administrative_area_level_1' &&
  //     d['types'][1] === 'political'
  //   ) {
  //     region = d['short_name'];
  //   }
  // }

  return region.toLowerCase();
}